import { render, staticRenderFns } from "./mobile-menu.vue?vue&type=template&id=2d52c0e4&lang=pug&"
import script from "./mobile-menu.vue?vue&type=script&lang=js&"
export * from "./mobile-menu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports